import React, {useContext, useEffect, useState} from 'react';
import Field from "../core/ui/forms/field";
import SessionContext from 'SessionContext';
import {useHistory} from "react-router-dom";
import { FormGroup } from 'reactstrap';
import DualSelect from "../partials/dual-select";
import isEqual from "lodash.isequal";
import ConfirmSuccess from "../core/ui/confirm-success";
import UnsavedChanges from "partials/unsaved-changes";

const channels_options_init = {
  "Direct Mail": false,
  "Email": false,
  "Digital": false,
  "Analytics": false
}

export default function InvoiceCategoryForm(props) {
  const session = useContext(SessionContext)
  const history = useHistory();
  const [modified, setModified] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [invoiceCategory, setInvoiceCategory] = useState({});
  const [disableSave, setDisableSave] = useState(true);
  const [invoiceCategoryEditing, setInvoiceCategoryEditing] = useState({});
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [errors, setErrors] = useState({
    id: '',
    name: '',
    description: '',
    qb_account: '',
    qb_invoice_item: '',
    invoice_category_type: '',
    unit_price: '',
  })

  const initialValues = {
    id: "",
    name: "",
    description: "",
    qb_account: "",
    qb_invoice_item: "",
    unit_price: "0.00",
    channel_option: "",
    invoice_category_type: "BaseRecord",
    
  };

  const [allBillingCodes, setAllBillingCodes] = useState([]);
  const [billingCodesLoaded, setBillingCodesLoaded] = useState(false);
  const [selectedBillingCodes, setSelectedBillingCodes] = useState([]);
  const availableChannelOptions = [
    {value: "Direct Mail", label: "Direct Mail", id: 2},
    {value: "Email", label: "Email Deployment", id: 1},
    {value: "Custom Digital Audience", label: "Digital Onboarding", id: 3},
    {value: "Analytics", label: "Analytics Only", id: 4},
  ];
  const [selectedChannelOptions, setSelectedChannelOptions] = useState(channels_options_init);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successLabel, setSuccessLabel] = useState("Updated!");

  // load up the channel options available
  // function loadChannelOptions() {
  //   session.query('admin/get_channel_options')
  //          .then((res) => {
  //           setAvailableChannelOptions(res)
  //          })
  // }

  // utility to find the selected channel options
  const getSelectedChannelOptions = () => {
    const selected_channels = Object.entries(selectedChannelOptions)
      .filter(([key, value]) => value === true)
      .map(([key]) => key);
    return selected_channels;
  }

  function loadInvoiceCategory(invoice_category_id) {
    setLoaded(false);
    session.query('admin/get_invoice_category', {id: invoice_category_id})
        .then((response) => {
          setInvoiceCategory(response)
          setSelectedBillingCodes(response.billing_codes.map((v) => {
            return {...v, value: ''}
          }))
          setBillingCodesLoaded(true);
          setSelectedChannelOptions((prevItems) => {
            let newChannelsInfo = {...channels_options_init};
            response.channel_options.forEach((_channel) => {
              newChannelsInfo[_channel.name] = true;
            });
            return newChannelsInfo;
          });
          setLoaded(true);
        })
  }

  function loadBillingCodes() {
    session.query('reference/codes/invoice_billing')
      .then((codes) => {
        setAllBillingCodes(codes.map((v) => {
          return {...v, value: ''}
        }))
        setBillingCodesLoaded(true);
      })
  }

  useEffect(() => {
    if (!billingCodesLoaded) {
      loadBillingCodes();
    }
    if (props.args.invoice_category_id) {
      loadInvoiceCategory(props.args.invoice_category_id);
    } else {
      setInvoiceCategory({...initialValues});
      setLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const storeOldValues = () => {
      if(invoiceCategory.id !== invoiceCategoryEditing.id) {
        setInvoiceCategoryEditing(invoiceCategory);
      }
    }

    const checkForEmpty = () => {
      if(
        !invoiceCategory.description.length ||
        !invoiceCategory.invoice_category_type.length ||
        !invoiceCategory.name.length ||
        !invoiceCategory.qb_account.length ||
        !invoiceCategory.qb_invoice_item.length ||
        !invoiceCategory.unit_price.length ||
        !getSelectedChannelOptions().length
      ) {
        setDisableSave(true);
      } else {
        setDisableSave(false);
      }
    }

    const checkForChanges = () => {
      let hasChanged = isEqual(invoiceCategory, invoiceCategoryEditing); // true if equal

      // check if Billing Codes changed
      if(hasChanged) {
        let selected_billing_codes = [...selectedBillingCodes];
        selected_billing_codes.length && selected_billing_codes.map((bc) => {
          delete bc.value;
          return {...bc}
        });
        hasChanged = isEqual(invoiceCategoryEditing.billing_codes, selected_billing_codes);
      }

      // check if Channel Options changed
      if(hasChanged) {
        let prevChannels = {...channels_options_init};
        invoiceCategoryEditing.channel_options.forEach((_ch) => {
          prevChannels[_ch.name] = true;
        })
        hasChanged = isEqual(prevChannels, selectedChannelOptions);
      }

      if(hasChanged) {
        setDisableSave(true);
        setModified(false);
      } else {
        setDisableSave(false); 
        setModified(true);
      }
    }

    if(invoiceCategory && Object.keys(invoiceCategory).length !== 0) {
      storeOldValues();
      checkForEmpty();
      if(invoiceCategory.id) {
        checkForChanges();
      }
    } 
  // eslint-disable-next-line
  }, [invoiceCategory, invoiceCategoryEditing, selectedBillingCodes, selectedChannelOptions])

  function onClickSave(ev) {
    ev.stopPropagation();
    ev.preventDefault();

    const newErrors = {}
    if (!invoiceCategory.qb_account) newErrors.qb_account = 'Required'
    if (!invoiceCategory.qb_invoice_item) newErrors.qb_invoice_item = 'Required'
    if (!invoiceCategory.invoice_category_type) newErrors.invoice_category_type = 'Required'
    if (!invoiceCategory.unit_price) newErrors.unit_price = 'Required'
    setErrors(newErrors)
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    // format the selected channel for api
    const formatted_channels = [];

    getSelectedChannelOptions().forEach((val) => {
      let findInfo = availableChannelOptions.find((info) =>  info.value === val);
      formatted_channels.push({
        name: findInfo.value,
        id: findInfo.id
      });
    })

    const newInvoiceCategory = {
      ...invoiceCategory,
      channel_options: formatted_channels
    }

    newInvoiceCategory.billing_codes = selectedBillingCodes.map((bc) => {
      return {...bc, value:''}
    })

    if (!!newInvoiceCategory.id) {
      session.command('admin/update_invoice_category', newInvoiceCategory, {}, { defaultErrorHandling: false })
        .then((response) => {
          setModified(false);
          setShowSuccess(true);
          setSuccessLabel("Invoice Category Updated!");
          setTimeout(() => {
            setHasUnsavedChanges(false);
            history.push('admin-invoice-categories');
          }, 2000);
        })
        .catch((error) => {
          console.log("InvoiceCategory Update Failed", JSON.stringify(error))
        })
    }
    else {
      session.command('admin/create_invoice_category', newInvoiceCategory, {}, { defaultErrorHandling: false })
        .then((response) => {
          setModified(false);
          setShowSuccess(true);
          setSuccessLabel("Invoice Category Created!");
          setTimeout(() => {
            setHasUnsavedChanges(false);
            history.push('admin-invoice-categories');
          }, 2000);
        })
        .catch((error) => {
          console.log("InvoiceCategory Create Failed", JSON.stringify(error))
        })
    }
  }

  function setName(ev) {
    setInvoiceCategory({...invoiceCategory, name: ev.target.value})
    if (ev.target.value) {
      setErrors((prev) => delete prev.name)
      setModified(true);
    }
  }

  function setDescription(ev) {
    setInvoiceCategory({...invoiceCategory, description: ev.target.value})
    if (ev.target.value) {
      setErrors((prev) => delete prev.description)
      setModified(true);
    }
  }

  function setQbAccount(ev) {
      setInvoiceCategory({ ...invoiceCategory, qb_account: ev.target.value })
      if (ev.target.value) {
        setErrors((prev) => delete prev.qb_account)
        setModified(true);
      }
  }

  function setQbInvoiceItem(ev) {
    setInvoiceCategory({ ...invoiceCategory, qb_invoice_item: ev.target.value })
    if (ev.target.value) {
      setErrors((prev) => delete prev.qb_invoice_item)
      setModified(true);
    }
  }

  function setInvoiceCategoryType(ev) {
    setInvoiceCategory({ ...invoiceCategory, invoice_category_type: ev.target.value })
    if (ev.target.value) {
      setErrors((prev) => delete prev.invoice_category_type)
      setModified(true);
    }
  }

  function setUnitPrice(ev) {
    /* Make sure we have a decimal value with at most one . and at least 2 digits after the . */
    const allowedRegex=/^[[0-9]*(\.[0-9]*)?$/;
    if (! ev.target.value.match(allowedRegex)) {return;}
    setInvoiceCategory( {...invoiceCategory, unit_price: ev.target.value })
    if (ev.target.value) {
      setErrors((prev) => delete prev.unit_price)
      setModified(true);
    }
  }

  function goBack() {
    history.push('/admin-invoice-categories')
  }

  const onChannelOptionChange = (ev) => {
    let isChecked = ev.target.checked;
    let value = ev.target.value;
    
    setSelectedChannelOptions((prevItems) => {
      return {
        ...prevItems,
        [value]: isChecked,
      };
    });
    setModified(true);
  }

  useEffect(() => {
    const checkIfHasUnsavedEdits = () => {
      if(invoiceCategory.id) {
        // handle editing existing
        setHasUnsavedChanges(modified);
      } else {
        // handle creating new
        const initialChannelOptions = {
          "Direct Mail": false,
          "Email": false,
          "Digital": false,
          "Analytics": false
        }
        let hasNewValues = false;
        for (const key in invoiceCategory) {
          if (invoiceCategory[key] !== initialValues[key]) {
            hasNewValues = true; // something changed
          }
        }
        // check if the channels or billing options changed
        if( selectedBillingCodes.length || !isEqual(initialChannelOptions, selectedChannelOptions) ) {
          hasNewValues = true; // something changed
        }
        setHasUnsavedChanges(hasNewValues);
      }
    }

    checkIfHasUnsavedEdits();
  // eslint-disable-next-line
  }, [invoiceCategory, modified, selectedBillingCodes, selectedChannelOptions])

  return (  loaded &&
    <div className='page admin-page invoice-category-form-page'>
      <div className="list-header sticky-page-header">
        <button className='new-button' onClick={goBack}>
        <i className="bi bi-chevron-left" /> Back
        </button>
        <h1>Invoice Category</h1>
        <i className="spacer"/>
        <button className='new-button promote' onClick={onClickSave} disabled={disableSave}>Save Changes</button>
      </div>
      <section className='form-details'>

        <Field label='* Name' className='label-wrapper' error={errors.name}>
          <input type='text'
            value={invoiceCategory.name}
            className='info'
            onChange={setName} />
        </Field>
        <Field label='* Description' className='label-wrapper' error={errors.description}>
          <input type='text'
            value={invoiceCategory.description}
            className='info'
            onChange={setDescription} />
        </Field>
        <Field label='* QuickBooks Account' className='label-wrapper' error={errors.qb_account}>
          <input type='text'
            value={invoiceCategory.qb_account}
            className='info'
            onChange={setQbAccount} />
        </Field>

        <Field label='* QuickBooks Invoice Item' className='label-wrapper' error={errors.qb_invoice_item}>
          <input type='text'
            value={invoiceCategory.qb_invoice_item}
            className='info'
            onChange={setQbInvoiceItem} />
        </Field>

        <Field  label='* Invoice Category Type' className='label-wrapper' error={errors.invoice_category_type}>
          <div className='info category-type'>
            <div>
              <input type='radio'
                value='BaseRecord'
                onChange={setInvoiceCategoryType}
                checked = {invoiceCategory.invoice_category_type === 'BaseRecord'}/>
              Base Record
            </div>
            <div>
            <input type='radio'
              value='AddOn'
              onChange={setInvoiceCategoryType}
              checked = {invoiceCategory.invoice_category_type === 'AddOn'}/>
            Add On
            </div>
          </div>
        </Field>

        <Field label='* Channel Options' className='label-wrapper'>
          <div className="form-controls radio info category-type">

            {availableChannelOptions.map((channel) => {
              return (
                <FormGroup inline key={channel.id}>
                  <input
                    id={channel.value}
                    type="checkbox"
                    value={channel.value}
                    checked={selectedChannelOptions[channel.value]}
                    onChange={(ev) => onChannelOptionChange(ev)}
                  />
                  <label className="nowrap" htmlFor={channel.value}>
                    {channel.label}
                  </label>
                </FormGroup>
              );
            })}
          </div>
                            
        </Field>

        <Field label='* Unit Price' className='label-wrapper' error={errors.unit_price}>
          <input type='text'
            value={invoiceCategory.unit_price}
            className='info'
            onChange={setUnitPrice} />
        </Field>

      </section>
      <DualSelect name={'Billing Codes'}
                  optionLabel='description'
                  allOptions={allBillingCodes}
                  selectedOptions={selectedBillingCodes}
                  setSelectedOptions={setSelectedBillingCodes}
                  availableOptionsRender={(o) => <>{`${o.code}: ${o.description}`}</>}
                  selectedOptionsRender={(o) =>
                   <>{`${o.code}: ${o.description}`}</>
                  }
      />
      <div>
        <UnsavedChanges hasUnsavedChanges={hasUnsavedChanges} />
        <ConfirmSuccess show={showSuccess} label={successLabel} />
      </div>
    </div>
  )
}
